<template>
  <el-select size="small" popper-class="condition_popper_select" v-model="selectValue" style="width: 200px">
    <el-option v-for="opt of options" :key="opt.value" :label="opt.label" :value="opt.value">{{ opt.label }}</el-option>
  </el-select>
</template>

<script>
import { selectValueMixins } from './mixins'

export default {
  name: 'ConditionMatchSelect',
  mixins: [selectValueMixins],
  data() {
    return {
      options: [
        { label: '满足以下全部条件', value: '1' },
        { label: '满足以下任一条件', value: '2' }
      ]
    }
  }
}
</script>
